import { useEffect, useState } from 'react'
import API from '../../../api'
import { getProductCategory } from '../../dive-guides/gtm-events'
import { convertCurrency } from '../../helpers'

let controller, signal

const useActivitiesList = (type, selectedCurrency, diveCenterId, inViewport) => {
  const [isLoading, setIsLoading] = useState(true)
  const [activities, setActivities] = useState([])
  const [params, setParams] = useState({ limit: 8, offset: 0 })

  useEffect(() => {
    fetchData()
  }, [inViewport])

  // todo: remove if it will be without pagination
  // const [isShowPlaceholder, setIsShowPlaceholder] = useState(false)
  // const [total, setTotal] = useState(0)
  // useEffect(() => {
  //   setParams({ limit: 8, offset: 0 })
  //   setIsShowPlaceholder(true)
  // }, [queryFilters])

  const fetchData = () => {
    if(!inViewport) {
      return { activities }
    }
    if('AbortController' in window) {
      controller = new window.AbortController()
      signal = controller.signal
    }
    setIsLoading(true)
    const filter = { uniq_activity: true }
    API(
      `/api/adventure/v1/dive-centers/${diveCenterId}/activities/other/`,
      signal,
    )
      .get(filter)
      .then((items) => {
        if(!items.ok) {
          setActivities([])
        }
        setActivities(type === 'courses' ? items : items.results)

        const impressions = []
        items.results &&
          items.results.forEach((product, index) => {
            const { type, activityPageType } = getProductCategory(
              product.activityType,
            )
            product.position = index + 1
            const { originCurrency, originValue } = product.minimumPrice
            product.impression = {
              name: product.titleEn || product.title,
              id: product.id,
              price: convertCurrency(
                originValue,
                originCurrency,
                selectedCurrency,
                false,
                true,
              ).toFixed(2),
              brand: `${product.diveCenterTitle}|${window.affiliateId}`,
              category: type,
            }
            product.actionField = activityPageType
            impressions.push({
              ...product.impression,
              list: product.actionField,
              position: index + 1,
            })
          })
        if(items.results && items.results.length) {
          window.dataLayer.push({
            event: 'impression',
            ecommerce: {
              currencyCode: selectedCurrency,
              impressions: impressions,
            },
          })
        }
        setIsLoading(false)
      })
      .catch((error) => {
        if(error.name !== 'AbortError') {
          setIsLoading(false)
        }
      })
  }

  return {
    activities,
    isLoading,
    // isShowPlaceholder,
    // total,
    params,
    setParams,
  }
}

export default useActivitiesList
